import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { locationManager } from '@telegram-apps/sdk-react';

import { SystemModalContainer } from '@/components/common/SystemModal/SystemModal.tsx';
import { MainButton } from '@/components/common/MainButton/MainButton.tsx';
import LocationShape from '@/components/common/svg/shapes/LocationShape.tsx';
import { Image } from '@/components/common/Image/Image.tsx';

export const GeolocationModal: FC<{
  handleClose: () => void;
}> = ({ handleClose }) => {
  const { t } = useTranslation();

  const onClick = () => {
    locationManager.openSettings();

    handleClose();
  };

  return (
    <SystemModalContainer
      headerTitle={t('geolocation')}
      handleClose={handleClose}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px',
          padding: '24px 0'
        }}
      >
        <LocationShape width={80} height={80} fillColor="#000" />
        <p
          style={{
            color: '#808080',
            fontSize: '14px',
            textAlign: 'center',
            maxWidth: '90%',
            margin: 0
          }}
        >
          {t('geolocation.allow_geolocation_usage')}
        </p>
        <Image
          src="/geo_light.gif"
          alt="loading..."
          style={{
            maxWidth: '100%',
            borderRadius: 10,
            height: 'auto',
            objectFit: 'contain'
          }}
        />
      </div>
      <MainButton onClick={onClick} text={t('geolocation.open_settings')} />
    </SystemModalContainer>
  );
};
